import type { EnumUnion } from '@dresscode-frontend/utility-types';
export const WorkerType = {
  EMPLOYEE: 'EMPLOYEE',
  BOARD_MEMBER: 'BOARD_MEMBER',
  CONTRACTOR: 'CONTRACTOR',
  COLLABORATOR: 'COLLABORATOR'
} as const;
export type WorkerType = EnumUnion<typeof WorkerType>;
export type LowerWorkerType = Lowercase<WorkerType>;